/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrderPayByTrackCreatePathOrderId,
	OrderPayByTrackCreateData,
	OrderPayByTrackCreateStatus200,
	OrderPayByTrackCreateStatus400,
} from "../types/OrderPayByTrackCreate.ts";

function getOrderPayByTrackCreateUrl(order_id: OrderPayByTrackCreatePathOrderId) {
	const res = { method: "POST", url: `/api/order/${order_id}/pay-by-track/` as const };

	return res;
}

/**
 * @description Оплата заказа с устройства по трек-браслету.
 * @summary оплата заказа с устройства по трек-браслету
 * {@link /api/order/:order_id/pay-by-track/}
 */
export async function orderPayByTrackCreate(
	order_id: OrderPayByTrackCreatePathOrderId,
	data: OrderPayByTrackCreateData,
	config: Partial<RequestConfig<OrderPayByTrackCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<OrderPayByTrackCreateStatus200, ResponseErrorConfig<OrderPayByTrackCreateStatus400>, OrderPayByTrackCreateData>({
		method: "POST",
		url: getOrderPayByTrackCreateUrl(order_id).url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
